import Vue from 'vue';

import MobileMenu from './components/MobileMenu';
import Modal from './components/Modal'
import Carousel from './components/Carousel';
import LazyImage from './components/LazyImage';

Vue.component('mobile-menu', MobileMenu);
Vue.component('carousel', Carousel);
Vue.component('modal', Modal);
Vue.component('lazy-image', LazyImage);